import HttpClient from '../../gateway/HttpClient';
import { notUndefined } from '../../util/Assert';
import HttpMethod from '../../constant/HttpMethod';
import { TrackerMethods } from '../../constant/MethodNames';
import { query } from '@trlogic/client-js';
import { ActionType } from '../../constant/Constants';
import TrackerClient from './TrackerClient';
import Tracker from '../../domain/tracker/Tracker';
import Query = query.Query;
import Filter = query.Filter;

class NestTrackerClient implements TrackerClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'Http client cannot be undefined');
    this.httpClient = httpClient;
  }

  public save(tracker: Tracker): Promise<void> {
    const dto = { id: tracker.name, tracker: tracker };
    return this.httpClient.execute(HttpMethod.POST, TrackerMethods.SAVE, dto);
  }

  public remove(name: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.DELETE, `${TrackerMethods.REMOVE}/${name}`);
  }

  public deploy(name: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.POST, `${TrackerMethods.DEPLOY}/${name}`);
  }

  public undeploy(name: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.POST, `${TrackerMethods.UNDEPLOY}/${name}`);
  }

  public isExist(name: string): Promise<boolean> {
    return this.httpClient.execute(HttpMethod.GET, `${TrackerMethods.EXIST}/${name}`);
  }

  public count(query: Query): Promise<number> {
    return this.httpClient.execute(HttpMethod.POST, TrackerMethods.COUNT, query);
  }

  public getNames(filter: Filter): Promise<string[]> {
    return this.httpClient.execute(HttpMethod.GET, TrackerMethods.GET_NAMES, undefined, { filter });
  }

  public bulkAction(ids: string[], type: ActionType): Promise<{ id: string; error: any }[]> {
    const payload = { ids, type };
    return this.httpClient.execute(HttpMethod.POST, TrackerMethods.BULK_ACTION, payload);
  }
}

export default NestTrackerClient;
